import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

import { MessageTemplatesComponent } from './message-templates/message-templates.component';
import { CampaignSetupComponent } from './campaign-setup/campaign-setup.component';
import { CampaignsListComponent } from './campaigns-list/campaigns-list.component';
import { CampaignDetailsComponent } from './campaign-details/campaign-details.component';
import { AnalyticsDashboardComponent } from './analytics-dashboard/analytics-dashboard.component';

// NOTE: RepliesListComponent is intentionally omitted — Ankhan uses "Bot Messages".
@NgModule({
  declarations: [
    MessageTemplatesComponent,
    CampaignSetupComponent,
    CampaignsListComponent,
    CampaignDetailsComponent,
    AnalyticsDashboardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgbPaginationModule
  ]
})
export class WhatsappBulkModule { }
